exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-45fc9436] {\n  z-index: 1;\n}\n.width-wrapper[data-v-45fc9436] {\n  padding: .5rem 2rem;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n.centralize-info[data-v-45fc9436] {\n  position: absolute;\n  top: 3rem;\n  font-size: .7rem;\n  padding-left: .2rem;\n  vertical-align: vertical;\n  z-index: -1;\n}\n.square[data-v-45fc9436] {\n  height: 12px;\n  width: 12px;\n  margin-right: .2rem;\n  margin-bottom: 1rem;\n  border-radius: 2px;\n  z-index: -1;\n}\n", ""]);

// exports
